import { render, staticRenderFns } from "./AppHistoryHeader.vue?vue&type=template&id=7ff5b1e4&scoped=true&"
import script from "./AppHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./AppHistoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHistoryHeader.vue?vue&type=style&index=0&id=7ff5b1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5b1e4",
  null
  
)

export default component.exports